import { Suspense, lazy } from "react";

// Lazy load pages for code splitting
const Dashboard = lazy(() => import("./Pages/Dashboard"));
const Profile = lazy(() => import("./Pages/Profile"));
const JobSearch = lazy(() => import("./Pages/JobSearch"));
const JobDetails = lazy(() => import("./Pages/JobDetails"));
const StockDetails = lazy(() => import("./Pages/StockDetails"));
const Projects = lazy(() => import("./Pages/Projects"));
const CreateProject1 = lazy(() => import("./Pages/CreateProject1"));
const CreateProject2 = lazy(() => import("./Pages/CreateProject2"));
const CreateJob1 = lazy(() => import("./Pages/CreateJob1.js"));
const CreateJob2 = lazy(() => import("./Pages/CreateJob2"));
const CreateJob3 = lazy(() => import("./Pages/CreateJob3"));
const ProjectDetails = lazy(() => import("./Pages/ProjectDetails"));
const EquityDetails = lazy(() => import("./Pages/EquityDetails"));
const Skills = lazy(() => import("./Pages/Skills"));
const ApprovalRequestPage = lazy(() => import("./Pages/approvalRequest"));
const JobApplicantList = lazy(() => import("./Pages/JobApplicantList"));
const NdaAcknowledgement = lazy(() => import("./Pages/JobDetailsModels/NDAModels/NdaAcknowledgement"));
const NdaStep1 = lazy(() => import("./Pages/JobDetailsModels/NDAModels/NdaStep1"));
const NdaStep2 = lazy(() => import("./Pages/JobDetailsModels/NDAModels/NdaStep2"));
const Nda = lazy(() => import("./Pages/JobDetailsModels/NDAModels/Nda"));
const JobAgreementModal = lazy(() => import("./Pages/JobAgreementModel/JobAgreementModal"));
const Invoices = lazy(() => import("./Pages/invoices"));
const Bill = lazy(() => import("./Pages/bill"));
const BillDetails = lazy(() => import("./Pages/billDetails"));
const Users = lazy(() => import("./Pages/Users"));
const Income = lazy(() => import("./Pages/Income"));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <p>Loading...</p>
  </div>
);


export const routes = [
  {
    name: "Dashboard",
    element: <Suspense fallback={<LoadingFallback />}><Dashboard /></Suspense>,
    path: "/dashboard",
    requiredPermission: "dashboard",
  },
  {
    name: "Profile",
    element: <Suspense fallback={<LoadingFallback />}><Profile /></Suspense>,
    path: "/profile/:userId",
  },
  {
    name: "JobSearch",
    element: <Suspense fallback={<LoadingFallback />}><JobSearch /></Suspense>,
    path: "/jobSearch",
    // also allow lowercase path used by Sidebar
    alias: "/jobsearch",
    requiredPermission: "jobs",
  },

  {
    name: "JobDetails",
    element: <Suspense fallback={<LoadingFallback />}><JobDetails /></Suspense>,
    path: "/jobDetails/:jobId",
    requiredPermission: "jobs",
  },

  {
    name: "StockDetails",
    element: <Suspense fallback={<LoadingFallback />}><StockDetails /></Suspense>,
    path: "/stockDetails/:jobId",
    allowedRoles: ['admin', 'cashier'],
    requiredPermission: "stock",
  },

  {
    name: "projects",
    element: <Suspense fallback={<LoadingFallback />}><Projects /></Suspense>,
    path: "/projects",
    requiredPermission: "stock",
  },

  {
    name: "ProjectDetails",
    element: <Suspense fallback={<LoadingFallback />}><ProjectDetails /></Suspense>,
    path: "/projectdetails/:projId",
    requiredPermission: "stock",
  },
  {
    name: "jobapplicantlist",
    element: <Suspense fallback={<LoadingFallback />}><JobApplicantList /></Suspense>,
    path: "/jobapplicantlist/:jobId",
    requiredPermission: "jobs",
  },

  {
    name: "equitydetails",
    element: <Suspense fallback={<LoadingFallback />}><EquityDetails /></Suspense>,
    path: "/equitydetails/:projId",
    requiredPermission: "stock",
  },

  {
    name: "Skills",
    element: <Suspense fallback={<LoadingFallback />}><Skills /></Suspense>,
    path: "/Skills",
  },
  {
    name: "createproject1",
    element: <Suspense fallback={<LoadingFallback />}><CreateProject1 /></Suspense>,
    path: "/createproject1",
    requiredPermission: "stock",
  },
  {
    name: "createproject2",
    element: <Suspense fallback={<LoadingFallback />}><CreateProject2 /></Suspense>,
    path: "/createproject2",
    requiredPermission: "stock",
  },
  {
    name: "createjob1",
    element: <Suspense fallback={<LoadingFallback />}><CreateJob1 /></Suspense>,
    path: "/createjob1",
    requiredPermission: "jobs",
  },
  {
    name: "createjob2",
    element: <Suspense fallback={<LoadingFallback />}><CreateJob2 /></Suspense>,
    path: "/createjob2",
    requiredPermission: "jobs",
  },
  {
    name: "createjob3",
    element: <Suspense fallback={<LoadingFallback />}><CreateJob3 /></Suspense>,
    path: "/createjob3",
    requiredPermission: "jobs",
  },
  {
    name: "approvalRequest",
    element: <Suspense fallback={<LoadingFallback />}><ApprovalRequestPage /></Suspense>,
    path: "/approvalRequest",
  },
  {
    name: 'nda',
    element: <Suspense fallback={<LoadingFallback />}><Nda /></Suspense>,
    path: "/nda",
    requiredPermission: "jobs",
  },
  {
    name: 'ndaAcknowledgement',
    element: <Suspense fallback={<LoadingFallback />}><NdaAcknowledgement /></Suspense>,
    path: "/ndaAcknowledgement/:ndaId",
    requiredPermission: "jobs",
  },
  {
    name: 'NdaStep1',
    element: <Suspense fallback={<LoadingFallback />}><NdaStep1 /></Suspense>,
    path: "/NdaStep1/:ndaId",
    requiredPermission: "jobs",
  },
  {
    name: 'NdaStep2',
    element: <Suspense fallback={<LoadingFallback />}><NdaStep2 /></Suspense>,
    path: "/NdaStep2/:ndaId",
    requiredPermission: "jobs",
  },
  {
    name: 'JobAgreementModal',
    element: <Suspense fallback={<LoadingFallback />}><JobAgreementModal /></Suspense>,
    path: "/jobAgreement/:applicationId",
    requiredPermission: "jobs",
  },
  {
    name: 'invoices',
    element: <Suspense fallback={<LoadingFallback />}><Invoices /></Suspense>,
    path: "/invoices",
    requiredPermission: "invoice",
  },
  {
    name: 'users',
    element: <Suspense fallback={<LoadingFallback />}><Users /></Suspense>,
    path: '/users',
    allowedRoles: ['admin'],
    requiredPermission: "users",
  },
  {
    name: 'bill',
    element: <Suspense fallback={<LoadingFallback />}><Bill /></Suspense>,
    path: "/bill",
    requiredPermission: "invoice",
  },
  {
    name: "BillDetails",
    element: <Suspense fallback={<LoadingFallback />}><BillDetails /></Suspense>,
    path: "/billDetails/:sellInvoiceId",
    requiredPermission: "invoice",
  },
  {
    name: 'income',
    element: <Suspense fallback={<LoadingFallback />}><Income /></Suspense>,
    path: "/income",
    allowedRoles: ['admin', 'cashier'],
    requiredPermission: "income",
  },

];
